<template>
  <form name="form-enquiry" method="POST" data-netlify="true" data-netlify-honeypot="bot-field">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">electrify.com
            <span class="is-pulled-right">Purchase Enquiry</span>
        </p>
      </header>
      <section class="modal-card-body">

        <input type="hidden" name="form-name" value="form-support">

        <b-field>
        <div class="is-justify-content-center is-align-content-center" style="text-align: center;">
        <strong>- electrify.com -</strong> <br>premium domain and brand<br>
        offers above $1M USD invited</div>
        </b-field>

        <b-field label="Your Name" horizontal>
          <b-input type="name" v-model="form.name" placeholder="Your name" required></b-input>
        </b-field>

        <b-field label="Your Email" horizontal>
          <b-input type="email" v-model="form.email" placeholder="Your email" required></b-input>
        </b-field>

        <b-field label="Your Offer" horizontal>
          <b-input type="offer" v-model="form.offer" placeholder="Offers above $1M USD invited" required></b-input>
        </b-field>

        <b-field label="Message" horizontal>
          <b-input type="textarea" v-model="form.message"></b-input>
        </b-field>

<!--        <b-field label="Markets" horizontal>
            <b-checkbox-button v-model="form.markets"
                native-value="Auto">
                Auto
            </b-checkbox-button>
            <b-checkbox-button v-model="form.markets"
                native-value="Industrial">
                Industrial
            </b-checkbox-button>
            <b-checkbox-button v-model="form.markets"
                native-value="Consumer">
                Consumer
            </b-checkbox-button>
                        <b-checkbox-button v-model="form.markets"
                native-value="Tech">
                Tech
            </b-checkbox-button>
            <b-checkbox-button v-model="form.markets"
                native-value="Other">
                Other
            </b-checkbox-button>
        </b-field>
      -->
      <!-- <b-field>

      </b-field> -->

      </section>
      <footer class="modal-card-foot" style="justify-content: flex-end; align-items: center;">
        <div class="is-hidden-mobile" style="text-align: left; font-style: italic; flex-grow: 1; color: #555"><b style="color: #444">electrify:</b> to excite intensely or suddenly; to thrill.</div>

        <button class="button" type="button" @click="handleClose()">Cancel</button>
        <button class="button is-primary" @click.prevent="handleSubmit()">Send</button>
      </footer>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: "EnquiryForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        offer: "",
        message: "",
        markets: [],
      },
    };
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleClose() {
      this.$parent.close();
    },
    handleSubmit() {
      if (!this.form.email) {
        Toast.open({
          message: "Please enter your email",
          type: "is-danger"
        });
        return;
      }

      if (!this.form.offer) {
        Toast.open({
          message: "Please enter your offer",
          type: "is-danger"
        });

        return;
      }

      const axiosConfig = {
        header: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      axios
        .post(
          "/form_enquiry",
          this.encode({
            "form-name": "form-enquiry",
            ...this.form
          }),
          axiosConfig
        )
        .then(() => {
          Toast.open({
            message: "Thank you! Your form has been submitted",
            type: "is-success"
          });
          this.handleClose();
        })
        .catch(() => {
          Toast.open({
            message:
              "Sorry for the inconvenience - an occurred when sending your submission. Could you please try emailing instead?",
            type: "is-warning"
          });
        });
    }
  }
};
</script>
